/**
 * The header checkbox of a page-scoped selection: add every row on the page to
 * the selection, or take every row on the page out of it. Rows selected on
 * other pages are left alone either way, which is what lets a selection be
 * built across pages.
 */
export function togglePageSelection(
  selectedIds: ReadonlySet<string>,
  pageIds: readonly string[],
  checked: boolean,
): Set<string> {
  const next = new Set(selectedIds);
  for (const id of pageIds) {
    if (checked) next.add(id);
    else next.delete(id);
  }
  return next;
}
